import { baseApi } from "../baseApi";

export const CustomerApi = baseApi.injectEndpoints({
   endpoints: (builder) => ({
        getCustomerList: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/stackerbee_mobile_wms.wms.api.get_customer_list1`,
                method: 'POST',
                body: {
                    ...customerData,
                    order_by: "`tabCustomer`.`modified` desc",
                },
            }),
             providesTags: ['customer'],
        }),
        getCustomerGroups: builder.query({
            query: () => `/api/resource/Customer Group`,
        }),
        getTerritoryList: builder.query({
            query: () => `/api/resource/Territory`,
        }),
        getLeadList: builder.query({
            query: () => `/api/resource/Lead`,
        }),
        getAccoountmangerList: builder.query({
            query: () => `/api/resource/User`,
        }),
        getCurrencyList: builder.query({
            query: () => `/api/resource/Currency`,
        }),
        getPriceList: builder.query({
            query: () => ({
                url: `/api/resource/Price List`,
                params: {
                    filters: JSON.stringify([["Price List", "selling", "=", 1]])
                }
            })
        }),
        getBAnkAccount: builder.query({
            query: () => `/api/resource/Bank Account`,
        }),
        getMaketsegment: builder.query({
            query: () => `/api/resource/Market Segment`,
        }),
        getIndustryType: builder.query({
            query: () => `/api/resource/Industry Type`,
        }),
        getCustomerAddresses: builder.query({
            query: (customerName) => ({
                url: `/api/resource/Address`,
                params: {
                    filters: JSON.stringify([
                        ["Dynamic Link", "link_doctype", "=", "Customer"],
                        ["Dynamic Link", "link_name", "=", customerName]
                    ])
                }
            })
        }),
        getContact: builder.query({
            query: () => `/api/resource/Contact`,
        }),
        getTaxcategory: builder.query({
            query: () => `/api/resource/Tax Category`,
        }),
        getTaxwithholding: builder.query({
            query: () => `/api/resource/Tax Withholding Category`,
        }),
        createCustomer: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/stackerbee_mobile_wms.wms.react_api.create_customer`,
                method: 'POST',
                body: customerData,
            }),
            invalidatesTags: ['customer']
        }),
        getCustomerDetails: builder.mutation({
            query: (customerData) => ({
                url: `/api/method/stackerbee_mobile_wms.wms.api.get_customer_details`,
                method: 'POST',
                body: customerData,
            }),
             providesTags: ['customer'],
        }),

        updateCustomer: builder.mutation({
            query: (payload) => ({
                url: '/api/method/stackerbee_mobile_wms.wms.react_api.update_customer',
                method: 'POST',
                body: payload,
            }),
             invalidatesTags: ['customer']
        }),
        getCustomerGroupCount: builder.query({
            query: () => ({
                url: '/api/method/frappe.client.get_count',
                params: {
                    doctype: 'Customer',
                },
            }),
        }),
        getCustomerList1: builder.mutation({
            query: ({ page, page_size }) => ({
                url: `stackerbee_mobile_wms.wms.api.get_customer_list1?page=${page}&page_size=${page_size}`,
                method: 'POST',
                body: {},
            }),
        }),

    })
});

export const { 
    useGetCustomerList1Mutation,
    useGetCustomerGroupCountQuery,
    useUpdateCustomerMutation,
    useGetCustomerDetailsMutation,
    useCreateCustomerMutation,
    useGetTaxwithholdingQuery,
    useGetTaxcategoryQuery,
    useGetContactQuery,
    useGetCustomerAddressesQuery,
    useGetIndustryTypeQuery,
    useGetMaketsegmentQuery,
    useGetBAnkAccountQuery,
    useGetPriceListQuery,
    useGetCurrencyListQuery,
    useGetAccoountmangerListQuery,
    useGetLeadListQuery,
    useGetTerritoryListQuery,
    useGetCustomerGroupsQuery,
    useGetCustomerListMutation
 } = CustomerApi;
